import React, { Fragment } from 'react';
import { modalStore } from '../../components/layout/modals/ModalStore';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { FormField } from '../../components/layout/form-fields/FormField';
import { notificationStore } from '../../components/layout/notifications/NotificationStore';
import { ModalComponent } from '../../components/layout/modals/ModalComponent';
import { candidatesStore } from './CandidatesStore';
import { CountryDropdown } from '../../components/layout/form-fields/inputs/CountryDropdown';

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name'),
	email: Yup.string().required().email().label('Email')
});

export class CandidateEdit extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					name: this.props.candidate.name,
					email: this.props.candidate.email,
					location: this.props.candidate.location || '',
					disabled: this.props.candidate.disabled,
					countryId: this.props.candidate.countryId || '',
					aboutMe: this.props.candidate.aboutMe || ''
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'CandidateEdit')}
			</Formik>
		);
	}

	renderEditName() {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<FormField
							required
							className="has-text-left"
							label="Name"
							field="name"
							type="text"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	renderEditLocation(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<div className="field has-text-left">
							<label className="subtitle is-7">Country</label>
							<div className="control">
								<CountryDropdown
									value={this.props.candidate.country}
									onValueChange={item => {
										formikBag.setFieldValue('countryId', item.id);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="columns">
					<div className="column is-full">
						<FormField
							className="has-text-left"
							label="City/State"
							field="location"
							type="text"
							placeholder="City/State"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	renderEditAbout() {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<FormField
							className="has-text-left"
							field="aboutMe"
							maxlength={200}
							type="textarea"
							placeholder="Please write a brief summary of your professional profile. Remember to write about yourself in the 3rd person (max 200 characters)"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				{
					{
						name: this.renderEditName(formikBag),
						location: this.renderEditLocation(formikBag),
						about: this.renderEditAbout(formikBag)
					}[this.props.editAttribute]
				}
			</Fragment>
		);
	}

	async save(values) {
		candidatesStore
			.update({
				candidate: values
			})
			.then(result => {
				if (result.status === 'success') {
					notificationStore.pushNotification({
						type: notificationStore.SUCCESS_NOTIFICATION,
						title: 'Edit Candidate',
						message: 'The candidate has been successfully created.'
					});
					this.closeWithSuccess();
				} else {
					notificationStore.pushNotification({
						type: notificationStore.ERROR_NOTIFICATION,
						title: 'Edit Candidate',
						message: 'An error has occurred. Please try again.'
					});
					modalStore.closeDialog();
				}
			});
	}
}
